import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"margin-bottom":"10px"} }
const _hoisted_2 = { style: {"margin-bottom":"10px","display":"flex","align-items":"center","gap":"10px"} }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fa-light fa-copy" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Zkopírováno do schránky", -1)
const _hoisted_5 = { style: {"padding":"10px 15px","border-radius":"5px","background-color":"#eee","border":"1px solid #ddd","font-size":"14px","letter-spacing":"0.1rem"} }
const _hoisted_6 = { key: 0 }

import AuthorizedLayout from '@/layouts/AuthorizedLayout.vue';
import { NButton, NPopover } from 'naive-ui';

import useClipboard from 'vue-clipboard3';

import { ref, computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { toClipboard } = useClipboard();

const showPopover = ref<boolean>(false);

const inputUrl = ref('');

const resultUrl = computed(() => {
	const fixedUrl = fixUrl(inputUrl.value);

	// const params = {
	// 	timestamp: isTimestamp.value ? new Date().toISOString() : null,
	// 	'this-url-is-cool': isCool.value ? '1' : null,
	// 	'custom-param': customParam.value || null,
	// };

	// const finalUrl = updateUrlWithParams(fixedUrl, params);
	const tempUrl = replace(fixedUrl);

	return tempUrl;
});

const result = computed<{
	result: boolean;
	status?: 'ok' | 'error';
	errors?: string[];
	style?: string;
}>(() => {
	if (!inputUrl.value) return { result: false };

	try {
		validateUrl(resultUrl.value);

		return { result: true, status: 'ok', style: 'color: green;' };
	} catch (errors: any) {
		return {
			result: true,
			status: 'error',
			errors: Array.isArray(errors) ? errors : [],
			style: 'color: red;',
		};
	}
});

/** METHODS */
const copyToClipboard = async () => {
	await toClipboard(resultUrl.value);

	showPopover.value = true;

	setTimeout(() => {
		showPopover.value = false;
	}, 2000);
};

// const isTimestamp = ref(false);
// const isCool = ref(false);
// const customParam = ref('');

function replace(original: string) {
	const replacePairs = {
		'[timestamp]': '%%CACHEBUSTER%%',
	};

	return Object.entries(replacePairs).reduce((acc: string, current: [string, string]) => {
		return acc.replace(current[0], current[1]);
	}, original);
}

// function updateUrlWithParams(url: string, params: Record<string, string | null>) {
// 	if (!url) return null;

// 	// Remove trailing slash, question mark, or ampersand
// 	url = url.replace(/[\?\/&]$/, '');

// 	// Separate the URL from the hash
// 	const [baseUrl, hash] = url.split('#');

// 	// Filter out null or undefined params and construct query string
// 	const queryParams = new URLSearchParams();
// 	for (const [key, value] of Object.entries(params)) {
// 		if (value !== null && value !== undefined) {
// 			queryParams.set(key, value);
// 		}
// 	}
// 	const queryString = queryParams.toString();

// 	// Determine the correct separator
// 	const separator = baseUrl.includes('?') ? '&' : '?';

// 	// Reconstruct the URL with the new query parameters and hash (if present)
// 	return baseUrl + (queryString ? separator + queryString : '') + (hash ? `#${hash}` : '');
// }

function fixUrl(url: string): string {
	if (!url) return '';

	let tempUrl = url;

	// Remove leading/trailing spaces and trailing special characters
	tempUrl = tempUrl.trim().replace(/[?/&]$/, '');

	// Define common misspellings and incorrect formats
	const protocolTypos = [
		'http:///',
		'https:///',
		'http://',
		'https://',
		'http:/',
		'https:/',
		'http:',
		'https:',
		'http//',
		'https//',
		'http/',
		'https/',
		'htp://',
		'htps://',
		'htttp://',
		'httpps://',
		'http:\\',
		'https:\\',
		'http:\\\\',
		'https:\\\\',
		'http',
		'https',
		// Add more variations as needed
	];

	// Remove incorrect protocol if present
	for (let i = 0; i < protocolTypos.length; i += 1) {
		const typo = protocolTypos[i];

		if (tempUrl.startsWith(typo)) {
			tempUrl = tempUrl.substring(typo.length);
			break;
		}
	}

	// Prefix with "https://"
	tempUrl = `https://${tempUrl}`;

	// Split URL from hash
	const [baseUrl, hash] = tempUrl.split('#');

	// Remove trailing slash, question mark, or ampersand from baseUrl
	const cleanedUrl = baseUrl.replace(/[?/&]$/, '');

	return cleanedUrl + (hash ? `#${hash}` : '');
}

function validateUrl(url: string): boolean {
	const errors: string[] = [];

	try {
		const parsedUrl = new URL(url);

		// Check for invalid scheme (protocol)
		if (!['http:', 'https:'].includes(parsedUrl.protocol)) {
			errors.push('Neplatný schéma (protocol). Použij http or https.');
		}

		// Check for missing domain
		if (!parsedUrl.hostname) {
			errors.push('Chybí doména.');
		}

		// Check for missing first-order domain
		const domainParts = parsedUrl.hostname.split('.');

		if (
			domainParts.length < 2 ||
			domainParts.some((part) => part.trim() === '') ||
			!domainParts[1] ||
			domainParts[1].length < 2
		) {
			errors.push('Chybí doména 1. řádu nebo je neplatná (např.: .cz, .com).');
		}

		// Additional checks for query parameters can be added here
	} catch (error) {
		errors.push('Neplatná URL.');
	}

	if (errors.length > 0) {
		throw errors;
	}

	return true;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AuthorizedLayout, { title: "Validace URL" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputUrl).value = $event)),
          placeholder: "URL",
          style: {"width":"100%","font-size":"14px","border-radius":"5px","border":"1px solid #aaa","padding":"10px 15px"}
        }, null, 512), [
          [_vModelText, inputUrl.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(NPopover), {
          show: showPopover.value,
          placement: "top",
          trigger: "manual"
        }, {
          trigger: _withCtx(() => [
            _createVNode(_unref(NButton), {
              type: "primary",
              disabled: !_unref(resultUrl) || _unref(result).status === 'error',
              onClick: copyToClipboard
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["show"]),
        _createElementVNode("pre", _hoisted_5, _toDisplayString(_unref(resultUrl) || 'Vyplňte URL'), 1)
      ]),
      (_unref(result).result)
        ? (_openBlock(), _createElementBlock("ul", {
            key: 0,
            style: _normalizeStyle(_unref(result).style)
          }, [
            (_unref(result).status === 'ok')
              ? (_openBlock(), _createElementBlock("li", _hoisted_6, "URL je OK"))
              : _createCommentVNode("", true),
            (_unref(result).status === 'error' && _unref(result).errors && _unref(result).errors.length > 0)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(result).errors, (error, i) => {
                  return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(error), 1))
                }), 128))
              : _createCommentVNode("", true)
          ], 4))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})